/*
  DEFRAG - Sticky Cart Bar
  assets/sticky-cart-bar.js
*/

(function () {
  'use strict';

  function initStickyCartBar(bar) {
    var sectionId = bar.dataset.sectionId;
    var productId = bar.dataset.productId;

    var btn       = document.getElementById('scb-btn-' + sectionId);
    var select    = document.getElementById('scb-select-' + sectionId);
    var toast     = document.getElementById('scb-toast-' + sectionId);
    var qtyNum    = document.getElementById('scb-qty-num-' + sectionId);
    var qtyMinus  = document.getElementById('scb-qty-minus-' + sectionId);
    var qtyPlus   = document.getElementById('scb-qty-plus-' + sectionId);

    var dataEl = document.getElementById('scb-' + productId + '-data');
    var data = { variants: [] };
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    var currentVariantId = btn.dataset.variantId;
    var qty = 1;
    var isLoading = false;
    var hasVariants = !!select;

    var labelAdd  = 'カートに追加';
    var labelDone = 'カートに追加しました ✓';

    // 販売期間前チェック：固定バーを非表示
    if (bar.dataset.reservationBefore === 'true') {
      bar.style.display = 'none';
    }

    // 販売期間終了チェック：固定バーを非表示＋VTSをグレーアウト
    if (bar.dataset.reservationAfter === 'true') {
      bar.style.display = 'none';
      document.querySelectorAll('.vts-option').forEach(function(opt) {
        opt.classList.add('vts-option--soldout');
        var radio = opt.querySelector('.vts-radio');
        if (radio) radio.disabled = true;
      });
    }

    // 数量セレクター
    if (qtyMinus && qtyPlus && qtyNum) {
      qtyMinus.addEventListener('click', function () {
        if (qty > 1) { qty--; qtyNum.textContent = qty; }
      });
      qtyPlus.addEventListener('click', function () {
        qty++;
        qtyNum.textContent = qty;
      });
    }

    // VTSとの同期
    document.addEventListener('vts:variant-changed', function (e) {
      var variantId = String(e.detail.variantId);
      currentVariantId = variantId;
      btn.dataset.variantId = variantId;
      if (select) { select.value = variantId; }
      var variant = e.detail.variant;
      if (variant) {
        if (!isLoading) { btn.disabled = !variant.available; }
        btn.querySelector('.scb__btn-text').textContent = variant.available ? labelAdd : '売り切れ';
      }
    });

    // ドロップダウン変更 → VTSにも反映
    if (select) {
      select.addEventListener('change', function () {
        currentVariantId = select.value;
        btn.dataset.variantId = currentVariantId;
        var variant = data.variants.find(function (v) { return v.id == currentVariantId; });
        var vtsOptions = document.querySelectorAll('#vts-' + productId + ' .vts-option');
        vtsOptions.forEach(function (opt) {
          opt.classList.remove('vts-option--selected');
          if (String(opt.dataset.variantId) === currentVariantId) {
            opt.classList.add('vts-option--selected');
            var radio = opt.querySelector('.vts-radio');
            if (radio) radio.checked = true;
          }
        });
        if (variant) {
          var price = (variant.price / 100).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
          document.querySelectorAll('.price__regular .price-item--regular, .price-item--regular').forEach(function (el) {
            el.textContent = price;
          });
          btn.disabled = !variant.available;
          btn.querySelector('.scb__btn-text').textContent = variant.available ? labelAdd : '売り切れ';
        }
        var hiddenPickers = document.querySelectorAll('variant-selects, variant-radios');
        hiddenPickers.forEach(function (picker) {
          var radios = picker.querySelectorAll('input[type="radio"]');
          radios.forEach(function (radio) {
            if (radio.value === (select.options[select.selectedIndex] && select.options[select.selectedIndex].text)) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
        if (history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', currentVariantId);
          history.replaceState({}, '', url.toString());
        }
      });
    }

    // カートに追加
    btn.addEventListener('click', function () {
      if (btn.disabled || isLoading) return;
      isLoading = true;
      var originalQtyInput = document.querySelector('quantity-input input.quantity__input');
      if (originalQtyInput) {
        originalQtyInput.value = qty;
        originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      btn.classList.remove('scb__btn--waiting', 'scb__btn--done', 'scb__btn--animate');
      btn.classList.add('scb__btn--waiting');
      setTimeout(function() { btn.classList.add('scb__btn--animate'); }, 20);
      var originalBtn = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!originalBtn) {
        isLoading = false;
        btn.classList.remove('scb__btn--waiting', 'scb__btn--animate');
        return;
      }
      var attempts = 0;
      var maxAttempts = 20;
      function tryClick() {
        if (!originalBtn.disabled) {
          originalBtn.click();
          try { gtag('event', 'sticky_bar_add_to_cart', { variant_id: currentVariantId }); } catch(e) {}
          setTimeout(function () {
            btn.classList.remove('scb__btn--done', 'scb__btn--animate', 'scb__btn--waiting');
            showToast(labelDone);
            isLoading = false;
            btn.disabled = false;
          }, 1800);
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryClick, 100);
        } else {
          btn.classList.remove('scb__btn--waiting', 'scb__btn--animate', 'scb__btn--done');
          isLoading = false;
          btn.disabled = true;
          btn.querySelector('.scb__btn-text').textContent = '販売期間外です';
        }
      }
      setTimeout(tryClick, 50);
    });

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('scb__toast--show');
      setTimeout(function () { toast.classList.remove('scb__toast--show'); }, 2500);
    }

    // 商品タイトルをフックにIntersectionObserver
    var titleEl = document.querySelector('.product__title');
    if (!titleEl) return;

    document.body.appendChild(bar);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.add('scb--visible');
          bar.classList.remove('scb--phase2', 'scb--with-variant');
          bar.removeAttribute('aria-hidden');
        } else {
          var rect = entry.boundingClientRect;
          if (rect.top < 0) {
            bar.classList.add('scb--visible', 'scb--phase2');
            if (hasVariants) bar.classList.add('scb--with-variant');
            bar.removeAttribute('aria-hidden');
          } else {
            bar.classList.remove('scb--visible', 'scb--phase2', 'scb--with-variant');
            bar.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(titleEl);
  }

  function init() {
    document.querySelectorAll('.scb').forEach(function (bar) {
      initStickyCartBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();